import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { IDashboardState, IState } from '../states/dashboard';

function createGeneralSelectors(
  dashboardFeatureSelector: MemoizedSelector<IState, IDashboardState, DefaultProjectorFn<IDashboardState>>,
) {
  const selectSubsection = createSelector(
    dashboardFeatureSelector,
    (state: IDashboardState, props: { subsectionName: string }) => state.general[props.subsectionName],
  );

  return {
    selectSubsection,
  };
}

export default createGeneralSelectors;
